export const packsTooltipStyles = {
  container: { p: 1, minWidth: 300 },
  title: { fontWeight: 700, display: "block", mb: 0.75, fontSize: "0.72rem" },
  list: { maxHeight: 300, overflowY: "auto" as const },
  itemRow: (isLast: boolean) => ({
    py: 0.5,
    borderBottom: isLast ? "none" : "1px solid rgba(0,0,0,0.07)",
  }),
  statusRow: { display: "flex", alignItems: "center", gap: 0.75, mb: 0.25 },
  statusDot: (color: string) => ({
    width: 7,
    height: 7,
    borderRadius: "50%",
    flexShrink: 0,
    cursor: "help",
    bgcolor: color,
  }),
  statusLabel: (color: string) => ({
    fontSize: "0.7rem",
    fontWeight: 700,
    color,
  }),
  credits: {
    fontSize: "0.7rem",
    fontWeight: 600,
    ml: "auto",
    color: "text.primary",
  },
  dates: { fontSize: "0.65rem", color: "text.secondary", pl: 2 },
  dateLabel: { fontWeight: 600 },
  calcContainer: (withSeparator: boolean) => ({
    mt: withSeparator ? 0.75 : 0,
    pt: withSeparator ? 0.5 : 0,
    borderTop: withSeparator ? "1px solid rgba(0,0,0,0.15)" : "none",
  }),
  calcRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 2,
    fontSize: "0.68rem",
    color: "text.secondary",
    py: 0.1,
  },
  calcTotalRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 2,
    fontSize: "0.7rem",
    fontWeight: 700,
    mt: 0.25,
    color: "text.primary",
  },
};
